import React from "react";

const Wrapper = ({ children }) => children;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/_hoc/Wrapper/index.js